import * as yup from "yup";
import i18n from "i18next";
import { initializeYup } from "@duosoftbg/nacid-components";

export const createPasswordConfirmationValidationSchema = () => {
  initializeYup(yup);

  const passwordConfirmationValidationSchema = yup.object({
    password: yup.string().required(),
    confirmPassword: yup
      .string()
      .required()
      .oneOf([yup.ref("password"), null], i18n.t("validation.confirmPassword.incorrect")),
  });

  return passwordConfirmationValidationSchema;
};
